import { Text, Wrap, WrapItem } from '@podiumhq/design-system';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { getCreditCardIcon } from '../../CreditCardDetails/icons';

import { ConfirmDetailsSectionWrapper } from './ConfirmDetailsSectionWrapper';

const PaymentDetails = (props) => {
  const { isMobile, stripeDetails = {} } = useSelectPlanCheckoutContext() || {};
  const { cardType, lastFour } = stripeDetails;

  const cardIcon = getCreditCardIcon(cardType);

  return (
    <ConfirmDetailsSectionWrapper
      displayDivider={isMobile}
      title="Payment Method"
      id="fs-payment-method-change"
      {...props}
    >
      <Wrap>
        {!!cardIcon && (
          <WrapItem>
            <img src={cardIcon} alt={`${cardType} icon`} />
          </WrapItem>
        )}
        <WrapItem alignItems="center">
          <Text fontSize="xl" fontWeight="bold" letterSpacing="-2px">
            &middot; &middot; &middot;
          </Text>
          <Text fontSize="md" fontWeight="medium" ml="3px">
            {lastFour}
          </Text>
        </WrapItem>
      </Wrap>
    </ConfirmDetailsSectionWrapper>
  );
};

export default PaymentDetails;
